import { Component, Input, OnInit, OnDestroy, ViewChild } from '@angular/core';
import { WizardService } from './wizard.service';
import { BehaviorSubject } from 'rxjs/BehaviorSubject';
import { IField, RegistrationFormComponent } from '../registration/form/form.component';
import { merge, concat, omit } from 'ramda/es';

export interface IWizardForm {
  title: string;
  isFirst?: boolean;
  isLast?: boolean;
  fields: IField[];
  subscription: BehaviorSubject<any>;
}
@Component({
  selector: 'wizard-form',
  templateUrl: './wizard-form.component.html',
  styleUrls: ['./wizard.component.scss']
})
export class WizardFormComponent implements OnInit {
  @Input() props: IWizardForm;
  @ViewChild('form') form: RegistrationFormComponent;

  private option: any;

  constructor(private wizardService: WizardService) {}

  ngOnInit() {
    this.props = merge(this.props, {
      fields: concat(
        [{ name: 'Email', type: 'email', required: true, readonly: true }, { type: 'none', readonly: false }],
        this.props.fields
      )
    });
  }

  update(fields: IField[]) {
    const props = merge(this.props, { fields: fields.filter(field => field.type !== 'none') });
    this.wizardService.updateRegistrationForm(props);
  }
}



// WEBPACK FOOTER //
// ./src/app/modules/sessions/wizard/wizard-form.component.ts